export interface Article {
  id: string;
  title: string;
  file: string;
  order: number;
}

export interface ContentIndex {
  title: string;
  subtitle: string;
  articles: Article[];
}

// 中文内容索引
export const zhContent: ContentIndex = {
  title: "如何在 AI 时代工作",
  subtitle: "A Guide to Working with Artificial Intelligence",
  articles: [
    {
      id: "introduction",
      title: "一场奇怪的精神错乱正在蔓延",
      file: "01-content.md",
      order: 1
    },
    {
      id: "mindset",
      title: "构建模型其实很简单",
      file: "02-content.md",
      order: 2
    },
    {
      id: "tools",
      title: "用你的智能去帮助更多的人",
      file: "03-content.md",
      order: 3
    }
  ]
};

// 英文内容索引
export const enContent: ContentIndex = {
  title: "Learning to Work in the AI Era",
  subtitle: "A Guide to Working with Artificial Intelligence",
  articles: [
    {
      id: "introduction",
      title: "A Strange Madness is Spreading",
      file: "01-content.md",
      order: 1
    },
    {
      id: "mindset",
      title: "Building Models is Simple",
      file: "02-content.md",
      order: 2
    },
    {
      id: "tools",
      title: "Use Your Intelligence to Help More People",
      file: "03-content.md",
      order: 3
    }
  ]
};

// 根据语言获取内容索引
export function getContentIndex(lang: string): ContentIndex {
  return lang === 'en' ? enContent : zhContent;
}

// 获取内容目录路径
export function getContentPath(lang: string): string {
  return `../content/${lang}/`;
}

export default zhContent;
